import { AlertCircle, Check } from "lucide-react";
import LatexTextRendererMcq from "../../helper/Mathmcq";
import McqFormation from "./McqFormation";
import MatchFollowingEquation from "./MatchFollowingEquation";
import { use } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { path } from "../../Utils/ScreenPath";
import { convertIntoMath, noColumnInQuestion, XPattern, splitRectifyQuestion } from "../../helper/madeFinalObject";
import { dynamicSequence } from "../../helper/dynamicSequence";
import { ACTIONS } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";

export const QuestionBox = ({ question, onSelect, onReport }) => {
  const replaceMarkersInTable = (html, startId) => {
    if (!html) return html;
    let result = html;
    const startNum = parseInt(startId, 10);
    const matches = html.match(/\(x\d+\)\./g);
    if (matches) {
      matches.forEach((match) => {
        const idx = parseInt(match.match(/\d+/)[0], 10);
        const replacement = `${startNum + idx - 1}.`;
        const regex = new RegExp(`\\(x${idx}\\)\\.`, 'g');
        result = result.replace(regex, replacement);
      });
    }
    return result;
  };

  const navigation = useNavigate();
  let { sectionIndex, divisionIndex, qtypeId, chappterId, replaceId, EditId } = useParams();
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);

  const dispatch = useDispatch();

  const getCheckboxStyle = () => {
    if (!question.selected) return "border-gray-300 bg-white";
    if (question.isOr) return "border-orange-500 bg-orange-500";
    if (question.isAnd) return "border-green-500 bg-green-500";
    if (question?.isFreeze) return "border-gray-500 bg-gray-500";
    return "border-blue-500 bg-blue-500";
  };

  return (
    <div
      className={`mb-2 rounded-lg border-[3px] border-gray-300 ${question?.isFreeze
        ? "bg-gray-50 border-gray-200"
        : question?.selected
          ? "bg-green-50 border-green-200"
          : question?.book_question == "1"
            ? "border-1 border-blue-300 bg-blue-50"
            : ""
        } `}
    >
      <div className="flex items-start sm:items-center p-3 sm:p-4 gap-2"
        onClick={() => {
          if (!question.isFreeze) {
            if (replaceId) {
              const questionData = selectedData?.sections_info?.[sectionIndex]?.divisions?.[divisionIndex]?.question_data;
              const indexToEdit = questionData?.findIndex((q) => q.id === Number(EditId));
              const question_id = questionData[indexToEdit]?.question_id;


              const Finalquestion = {
                ...question,
                question_id: question_id,
                andId: questionData[indexToEdit]?.andId,
                selected: !questionData[indexToEdit]?.selected,
                isAnd: questionData[indexToEdit]?.isAnd,
                isOr: questionData[indexToEdit]?.isOr,
                // answers: questionData[indexToEdit]?.answers,
                // finalAnswers: questionData[indexToEdit]?.finalAnswers,
              };


              if (indexToEdit !== -1 && questionData) {
                const isParagraph = Finalquestion?.finalquestion?.includes('(x1).');
                const isMatch = Finalquestion?.perfact_metch?.length > 0 && !noColumnInQuestion.includes(Finalquestion.qtype);
                let incrementedId = parseInt(questionData[indexToEdit]?.question_id || "1", 10);

                // Remove the original
                questionData.splice(indexToEdit, 1);

                if (isParagraph) {
                  const subQuestions = splitRectifyQuestion(Finalquestion, incrementedId - 1, false);
                  subQuestions.forEach((subQ, idx) => {
                    questionData.splice(indexToEdit + idx, 0, {
                      ...subQ,
                      subID: Math.floor(Math.random() * 1000),
                    });
                  });
                } else if (isMatch) {
                  Finalquestion.perfact_metch.forEach((ele, ind) => {
                    questionData.splice(indexToEdit + ind, 0, {
                      ...Finalquestion,
                      ...(ind === 0 && { paragraph: convertIntoMath(Finalquestion?.finalquestion?.trim()) }),
                      question_id: (incrementedId + ind).toString(),
                      questionLeft: convertIntoMath(ele?.finalquestion),
                      questionRight: convertIntoMath(ele?.finalanswer),
                      rightAnswer: convertIntoMath(ele?.finalrightAnswer),
                      id: Finalquestion.id,
                      answer: convertIntoMath(Finalquestion?.answer),
                      question: '',
                      que_id: Finalquestion?.que_id,
                      html_tag: Finalquestion.html_tag || Finalquestion?.html_question,
                      andId: Finalquestion?.andId,
                      perfact_metch: [],
                    });
                  });

                } else {
                  // Normal question
                  questionData.splice(indexToEdit, 0, {
                    ...Finalquestion,
                    question_id: incrementedId.toString(),
                    question: convertIntoMath(Finalquestion.finalquestion),
                    id: Finalquestion.id,
                    qType: Finalquestion.qtype,
                    html_tag: Finalquestion.html_tag || Finalquestion?.html_question,
                    andId: Finalquestion?.andId,
                    answer: convertIntoMath(Finalquestion?.finalAnswer),
                    ...(Finalquestion.option1 || Finalquestion.option1_img) && {
                      answers: [
                        { answer: convertIntoMath(Finalquestion.option1 || ''), imgAnswers: Finalquestion.option1_img },
                        { answer: convertIntoMath(Finalquestion.option2 || ''), imgAnswers: Finalquestion.option2_img },
                        { answer: convertIntoMath(Finalquestion.option3 || ''), imgAnswers: Finalquestion.option3_img },
                        { answer: convertIntoMath(Finalquestion.option4 || ''), imgAnswers: Finalquestion.option4_img },
                      ],
                      finalAnswers: [
                        { answer: convertIntoMath(Finalquestion.finaloption1 || ''), imgAnswers: Finalquestion.option1_img },
                        { answer: convertIntoMath(Finalquestion.finaloption2 || ''), imgAnswers: Finalquestion.option2_img },
                        { answer: convertIntoMath(Finalquestion.finaloption3 || ''), imgAnswers: Finalquestion.option3_img },
                        { answer: convertIntoMath(Finalquestion.finaloption4 || ''), imgAnswers: Finalquestion.option4_img },
                      ],
                    },
                  });
                }

                // ✅ Resequence all question_id from 1 onward
                for (let i = 0; i < questionData.length; i++) {
                  questionData[i].question_id = (i + 1).toString();
                }

                // ✅ Save updated question list to Redux
                const updatedPayload = {
                  ...selectedData,
                  sections_info: selectedData?.sections_info?.map((section, sIdx) => {
                    if (sIdx === Number(sectionIndex)) {
                      return {
                        ...section,
                        divisions: section.divisions.map((division, dIdx) => {
                          if (dIdx === Number(divisionIndex)) {
                            return {
                              ...division,
                              question_data: questionData,
                            };
                          }
                          return division;
                        }),
                      };
                    }
                    return section;
                  }),
                };

                const dataObject = dynamicSequence(updatedPayload.sections_info);

                const finalOut = {
                  ...selectedData,
                  sections_info: dataObject,
                };

                dispatch(ACTIONS.getSelectedData(finalOut));

                setTimeout(() => {
                  navigation(path?.ManuallyGenerate + `/${true}?ts=${Date.now()}`);
                }, 10);


              }
            }
            onSelect(question.id);
          }
        }}
      >
        <div
          className={`flex-shrink-0 w-5 h-5 mt-1 sm:mt-0 border rounded flex items-center justify-center cursor-pointer ${getCheckboxStyle()}`}

        >
          {question.selected && <Check size={16} color="white" />}
        </div>
        {question?.m_equation != 1 ? (
          // **********************without m_equation*************************
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "-webkit-fill-available",
              overflow: "auto",
            }}
          >
            {question?.paragraph && (
              <div
                style={{ fontWeight: "600", marginBottom: "10px" }}
                dangerouslySetInnerHTML={{
                  __html: replaceMarkersInTable(question.paragraph, question.question_id),
                }}
                className="table-container"
              />
            )}
            {!question?.isInsideTable && (
              <div
                style={{ fontWeight: "600" }}
                dangerouslySetInnerHTML={{
                  __html: question?.finalquestion,
                }}
                className="table-container"
              />
            )}

            {(question?.option1_img ||
              question?.option2_img ||
              question?.option3_img ||
              question?.option4_img ||
              question?.finaloption1 ||
              question?.finaloption2 ||
              question?.finaloption3 ||
              question?.finaloption4) && <McqFormation question={question} />}

            {!question?.isInsideTable && question?.qtype != "12" && question?.perfact_metch?.length > 0 && (
              <MatchFollowingEquation data={question} />
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "-webkit-fill-available",
              overflow: "auto",
            }}
          >
            {/* *****************************with m_equation********************************** */}
            {question?.paragraph && (
              <div
                style={{ marginBottom: "10px" }}
                dangerouslySetInnerHTML={{
                  __html: replaceMarkersInTable(question.paragraph, question.question_id),
                }}
                className="table-container"
              />
            )}
            {!question?.isInsideTable && (
              <div
                dangerouslySetInnerHTML={{
                  __html: question?.finalquestion,
                }}
                style={{ width: "-webkit-fill-available" }}
                className="table-container"
              />
            )}

            <LatexTextRendererMcq text={question} />

            {/* match the following */}
            {!question?.isInsideTable && question?.qtype != "12" && question?.perfact_metch?.length > 0 && (
              <MatchFollowingEquation data={question} />
            )}
          </div>
        )}

        <div className="flex items-center space-x-2 ml-2 sm:ml-4">
          <AlertCircle
            className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 cursor-pointer"
            onClick={() => onReport(question)}
          />
        </div>
      </div>
    </div >
  );
};
